import React from 'react'
import PropTypes from 'prop-types'
import { Transition, animated } from 'react-spring/renderprops'
import { AlertTriangle, X } from '@entrata/portals-common/lib/icons'
import { getEmbeddedViewFlag } from 'portal-modules/common/utils/get-embedded-flag'
import styled from '@emotion/styled'

import { transparentize } from 'polished'

const StyledDiv = animated(
  styled('div')`
    width: 100%;
    background: ${({ theme }) => transparentize(0.05, theme.gray.dark)};
    border-top: 1px solid rgba(255, 255, 255, 0.5);
    color: white;
    padding: 16px;
    position: ${getEmbeddedViewFlag() ? 'fixed' : 'absolute'};
    bottom: 0;
    left: 0;
    z-index: 1;

    @media only screen and (min-width: 768px) {
      padding: 24px 48px;
    }
  `,
)

const StyledH6 = styled('h6')`
  font-size: 14px;
  font-weight: 500;
  margin: 0 0 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  svg {
    width: 16px;
    height: 16px;
    margin-right: 8px;
    vertical-align: middle;
  }

  @media only screen and (min-width: 768px) {
    font-size: 16px;

    svg {
      width: 20px;
      height: 20px;
      margin-right: 16px;
    }
  }
`

const StyledP = styled('p')`
  font-size: 13px;
  font-weight: 300;
  margin: 0;
`

const StyledButton = styled('button')`
  background-color: transparent;
  border: none;
  color: white;
  transition: background 250ms ease-in-out;
`

const Notice = ({ show, title, children, onClose }) => (
  <Transition
    items={show}
    from={{ opacity: 0, transform: 'translateY(100px)' }}
    enter={{ opacity: 1, transform: 'translateY(0px)' }}
    leave={{ opacity: 0, transform: 'translateY(100px)' }}
    native
  >
    {show =>
      show &&
      (styles => (
        <StyledDiv style={styles}>
          <StyledH6>
            <span>
              <AlertTriangle />
              {title}
            </span>
            {typeof onClose === 'function' && (
              <StyledButton onClick={onClose}>
                <X />
              </StyledButton>
            )}
          </StyledH6>
          <StyledP>{children}</StyledP>
        </StyledDiv>
      ))
    }
  </Transition>
)

Notice.propTypes = {
  show: PropTypes.bool,
  title: PropTypes.string.isRequired,
  children: PropTypes.any.isRequired,
  onClose: PropTypes.func,
}

export default Notice
